import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorGif } from './ErrorGif';
import { Layout, Subtitle, Text, Title } from './ErrorPage.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const UnknownError = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(Layout, {
      children: [/*#__PURE__*/_jsx(Title, {
        children: t('global.errorTitle')
      }), /*#__PURE__*/_jsx(Subtitle, {
        children: t('unknownError.title')
      }), /*#__PURE__*/_jsx(Text, {
        children: t('unknownError.description')
      })]
    }), /*#__PURE__*/_jsx(ErrorGif, {})]
  });
};